export const mainTextColor = '#ffffff'
export const accentColor = '#28a745'
export const secondColor = '#333333'
export const formBgColor = '#F4F4F4'
export const blogBgColor = '#0284D0'
export const labelColor = '#808080'
export const errorColor = '#d11212'
export const overlayBgColor = 'rgba(4, 4, 4, 0.5)'
export const boxShadow = '2px 2px 12px 2px rgba(0, 0, 0, 0.4)'

// timingFunc
export const duration = '250ms'
export const timingFunc = 'cubic-bezier(0.4, 0, 0.2, 1)'
